<template>
    <form @keydown="submitted = false"
          autocomplete="off"
          class="form-horizontal form-bordered form-row-stripped">

        <div class="form-group">
            <div class="control-label col-md-3">Stav</div>
            <div class="col-md-9">
               <div v-if="currentImport.active" class="badge badge-success mt-3">
                   Zapnutý
               </div>
               <div v-else class="badge badge-danger mt-3">Vypnutý</div>
            </div>
        </div>

        <div v-bind:class="[errors.mime_type ? 'has-error' : '', 'form-group']">
            <label for="xml" class="control-label col-md-3">Formát</label>
            <div class="col-md-9">
                <label class="radio-inline" for="xml">
                    <input type="radio" value="text/xml" id="xml" required="required" checked="checked" v-model="form.mime_type">
                    XML
                </label>
                <label class="radio-inline" for="csv">
                    <input type="radio" value="text/csv" id="csv" required="required" v-model="form.mime_type">
                    CSV
                </label>
            </div>
        </div>

        <div v-bind:class="[errors.url ? 'has-error' : '', 'form-group']">
            <label for="scheduleUrl" class="control-label col-md-3">Url adresa</label>
            <div class="col-md-9">
                <input v-bind:class="[errors.url ? 'is-invalid' : '', 'form-control']"
                       type="text"
                       @keydown="delete errors.url; submitted = false"
                       id="scheduleUrl"
                       placeholder="https://"
                       v-model="form.url">
                <span class="help-block"
                      v-text="errors.url[0]"
                      v-if="errors.url"
                ></span>
            </div>
        </div>

        <div v-bind:class="[errors.email_error ? 'has-error' : '', 'form-group']">
            <label for="inputEmailError" class="control-label col-md-3">Hlásenia chýb</label>
            <div class="col-md-9">
                <input v-bind:class="[errors.url ? 'is-invalid' : '', 'form-control']"
                       type="email"
                       @keydown="delete errors.email_error; submitted = false"
                       id="inputEmailError"
                       placeholder="E-mail"
                       v-model="form.email_error">
                <span class="help-block"
                      v-text="errors.email_error[0]"
                      v-if="errors.email_error"
                ></span>
            </div>
        </div>

        <div v-bind:class="[errors.email_ok ? 'has-error' : '', 'form-group']">
            <label for="inputEmailOk" class="control-label col-md-3">
                Hlásenia o úspešnom importe
            </label>
            <div class="col-md-9">
                <input v-bind:class="[errors.url ? 'is-invalid' : '', 'form-control']"
                       type="email"
                       @keydown="delete errors.email_ok; submitted = false"
                       id="inputEmailOk"
                       placeholder="E-mail"
                       v-model="form.email_ok">
                <span class="help-block"
                      v-text="errors.email_ok[0]"
                      v-if="errors.email_ok"
                ></span>
            </div>
        </div>

        <div class="form-group">
            <div class="col-md-9 col-md-offset-3">
                <button type="button" v-if="currentImport.active === false" class="btn btn-primary" @click="activate">
                    Aktivovať
                </button>
                <button type="button" v-if="currentImport.active" class="btn btn-default" @click="update">
                    Aktualizovať
                </button>
                <button type="button" v-if="currentImport.active" class="btn btn-danger" @click="deactivate">
                    Deaktivovať
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: ['importInstitution'],

        data() {
            return {
                currentImport: this.importInstitution,
                form: {
                    email_ok: this.importInstitution.email_ok,
                    email_error: this.importInstitution.email_error,
                    url: this.importInstitution.url,
                    active: true,
                    mime_type: this.importInstitution.mime_type
                },
                submitted: false,
                errors: {}
            }
        },

        methods: {
            update() {
                this.submitted = true;

                axios.patch('/admin/imports/' + this.currentImport.id, this.form)
                    .then(response => {
                        this.currentImport = response.data;
                        flash('Zmeny uložené.');
                    }).catch(errors => {
                        this.errors = errors.response.data.errors;
                    });
            },

            activate() {
                this.submitted = true;

                if (this.currentImport.id) {
                    axios.patch('/admin/imports/' + this.currentImport.id, this.form)
                        .then(response => {
                            this.currentImport = response.data;
                            flash('Automatický import bol aktivovaný.');
                        }).catch(errors => {
                            this.errors = errors.response.data.errors;
                        });
                } else {
                    axios.post('/admin/imports/' + this.currentImport.institution_id, this.form)
                        .then(response => {
                            this.currentImport = response.data;
                            flash('Automatický import bol aktivovaný.');
                        }).catch(errors => {
                            this.errors = errors.response.data.errors;
                        });
                }
            },

            deactivate() {
                this.submitted = true;

                axios.patch('/admin/imports/' + this.currentImport.id, { active: false })
                    .then(response => {
                        this.currentImport = response.data;
                        flash('Automatický import bol deaktivovaný.');
                    }).catch(errors => {
                        this.errors = errors.response.data.errors;
                    });
            }
        }
    }
</script>
